import { computed } from 'vue';
import { isFeatureEnabled } from '@/config/featureFlags';
import { useSlaPermissions } from '@/composables/use-sla-permissions';

/**
 * Wizard visibility for the Organizations list: the slaOrgWizard flag decides whether the
 * wizard replaces the legacy creation process at all, the caller's SLA grants decide
 * whether this user may see and start it (docs/sla-access.md). With the flag off nothing is
 * fetched and the legacy flow is untouched.
 */
export function useOrgWizardAccess() {
    const wizardEnabled = isFeatureEnabled('slaOrgWizard');
    const permissions = wizardEnabled ? useSlaPermissions() : null;

    /** The wizard is on and this caller holds at least one SLA grant. */
    const wizardAvailable = computed(() => permissions?.hasAnyAccess.value ?? false);
    /** This caller may start a new organization draft in the wizard. */
    const canCreateInWizard = computed(() => permissions?.can('WriteCreate') ?? false);

    return { wizardEnabled, wizardAvailable, canCreateInWizard };
}
